/***
 *
 *   BADGE STYLES
 *   Ported from ui-reference/src/components/ui/badge.tsx (badgeVariants).
 *
 *   Solid pills. For the softer bordered chip with a leading dot that the
 *   reference uses on ticket cards, see components/chip.
 *
 **********/

const Style = {
    base: 'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide',

    // -- variants ----------------------------------------------------------
    neutral: 'bg-muted text-muted-foreground',
    count: 'bg-primary-100 text-primary-700 dark:bg-primary-900/50 dark:text-primary-200',

    urgent: 'bg-priority-urgent text-white',
    high: 'bg-priority-high text-white',
    medium: 'bg-priority-medium text-white',
    low: 'bg-priority-low text-white',

    pending: 'bg-status-pending text-white',
    inProgress: 'bg-status-inProgress text-white',
    onHold: 'bg-status-onHold text-white',
    completed: 'bg-status-completed text-white',
    closed: 'bg-status-closed text-white',

    // LEGACY colour keys, kept so existing call sites keep working.
    red: 'bg-error text-white',
    blue: 'bg-primary-600 text-white',
    green: 'bg-success text-white',
    orange: 'bg-warning text-white',

    iconParent: 'ml-1 inline-flex shrink-0 cursor-pointer items-center',
};

export default Style;
